export function fileApplication(file: string) {
  let str = file.split('.');
  return str.splice(-1)[0];
}
